import { combineReducers } from "redux";
import rentalproperty from "../features/admin/rental/Slice";

const rental = combineReducers({
  rentalproperty: rentalproperty,
});

export default rental;
